import { clientConfig } from '../config';

/**
 * A resource is RLT-gated when:
 *   - its Id is in NEXT_PUBLIC_RLT_RESTRICTED_RESOURCE_IDS, AND
 *   - the logged-in coworker does not have Custom10 === 'APPROVED'
 *
 * When gated, the portal disables the booking button and prompts the user
 * to complete the Red Light Therapy PAR-Q in the Bruntwood Passport app.
 */
export const isResourceRltRestricted = (
  resourceId: number | undefined,
): boolean => {
  if (!resourceId) return false;
  const { rltRestrictedResourceIds } = clientConfig();
  return rltRestrictedResourceIds.includes(resourceId);
};

export const isResourceRltGated = (
  resourceId: number | undefined,
  custom10: string | undefined | null,
): boolean => {
  if (!isResourceRltRestricted(resourceId)) return false;
  return custom10 !== 'APPROVED';
};
